import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { OktaAuthService } from "@okta/okta-angular";
import { Observable } from "rxjs";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private oktaAuth: OktaAuthService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    var accessToken = this.oktaAuth.getAccessToken();

    return next.handle(request.clone({ setHeaders: accessToken != undefined ? { Authorization: `Bearer ${accessToken}` } : {} }));
  }
}